import {Pagination} from '@src/models/pagination';
import {api} from './client';
import {ChatListResponse, ChatUser, ContactReq, Message} from '@src/models/message';

export interface getMessagesReq {
  page: number;
}
export interface getChatListReq{
  page:number;
  search?:string;
  sort_by: string;
  seen?: boolean
}
export interface getArchiveChatListReq{
  page:number;
  search?:string;
}
export namespace MessagesApi {
  export const getMessages = async (params:getChatListReq) => {
    const res = await api.get<ChatListResponse>(`contacts/chats`, {params: params});
    return res.data;
  };
  export const getArchiveChats = async (params:getArchiveChatListReq) => {
    const res = await api.get<ChatListResponse>(`chats/archived`, {params: params});
    return res.data;
  };
  export const getChatUser = async (id: string) => {
    const res = await api.get<ChatUser>(`chats/users/${id}`);
    return res.data;
  };
  export const getMessagesInChat = async (
    id: string,
    params: getMessagesReq
  ) => {
    const res = await api.get<Pagination<Message>>(`/chats/users/${id}/messages`, {
      params: {page: params.page},
    });
    return res.data;
  };
  export const deleteChat = async(id: string)=>{
    const res = await api.delete('chats/users/'+id);
    return res.data
  }
  export const archiveChat = async (id: string) =>{
    const res = await api.patch(`chats/users/${id}/archive`);
    return res.data
  }
  export const unArchiveChat = async (id: string) =>{
    const res = await api.patch(`chats/users/${id}/unarchive`);
    return res.data
  }
  export const sendFileInChat = async(formData: FormData) =>{
    // A hanging upload would keep the chat locked behind the loading overlay.
    const res = await api.post(`chats/messages`, formData, {timeout: 120000});
    return res.data
  }
  export const addContact = async(id:string) =>{
    const res = await api.post(`contacts`, {'userToInviteId':id});
    return res.data
  }
  export interface getContactReq{
    page: number,
    search?: string
  }
  export const getContactReq = async(params:getContactReq) =>{
    const res = await api.get<Pagination<ContactReq>>(`contacts/invitations`,{params:params});
    return res.data
  }
  export const getSendInvitationsReq = async(params:getContactReq) =>{
    const res = await api.get<Pagination<ContactReq>>(`contacts/sent-invitations`,{params:params});
    return res.data
  }
  export const acceptContact = async(contactId: string)=>{
    const res = await api.patch(`contacts/${contactId}/accept`);
    return res.data
  }
  export const retreatContactInvitation = async(contactId: string)=>{
    const res = await api.patch(`contacts/${contactId}/retreat`);
    return res.data
  }
}
